module.exports = __webpack_public_path__ + "eduardo_suplicy--1f111123.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/eduardo_suplicy.jpg
// module id = 162
// module chunks = 0